import { HardDrive, Settings, Trash2 } from 'lucide-react'
import classNames from 'classnames'

import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'

interface MediaSidebarProps {
  activeSection: 'files' | 'favorites' | 'trash' | 'settings'
  setActiveSection: (section: 'files' | 'favorites' | 'trash' | 'settings') => void
  onNavigateRoot: () => void
}

export const MediaSidebar = ({
  activeSection,
  setActiveSection,
  onNavigateRoot,
}: MediaSidebarProps) => {
  return (
    <div className="flex w-full shrink-0 flex-col gap-0.5 lg:w-56">
      <Button
        variant={activeSection === 'files' ? 'secondary' : 'ghost'}
        className={classNames(
          "h-8 w-full justify-start gap-2 rounded-lg px-2 text-sm font-medium",
          activeSection === 'files' ? "text-ink" : "text-text-2 hover:text-ink"
        )}
        onClick={() => {
          setActiveSection('files')
          onNavigateRoot()
        }}
      >
        <HardDrive className="size-4" />
        All files
      </Button>

      <Button
        variant={activeSection === 'trash' ? 'secondary' : 'ghost'}
        className={classNames(
          "h-8 w-full justify-start gap-2 rounded-lg px-2 text-sm font-medium",
          activeSection === 'trash' ? "text-ink" : "text-text-2 hover:text-ink"
        )}
        onClick={() => setActiveSection('trash')}
      >
        <Trash2 className="size-4" />
        Trash
      </Button>
      <Separator className="my-1 bg-border-subtle" />

      <Button
        variant={activeSection === 'settings' ? 'secondary' : 'ghost'}
        className={classNames(
          "h-8 w-full justify-start gap-2 rounded-lg px-2 text-sm font-medium",
          activeSection === 'settings' ? "text-ink" : "text-text-2 hover:text-ink"
        )}
        onClick={() => setActiveSection('settings')}
      >
        <Settings className="size-4" />
        Settings
      </Button>

    </div>
  )
}
